/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';
import PropTypes, { number, string, bool } from 'prop-types';
import { Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingBox } from '@fortawesome/pro-solid-svg-icons';
// import { faBan } from '@fortawesome/pro-regular-svg-icons';

export function InventoryGridRow(props) {
  const [selectedItem, setSelectedItem] = useState(false);
  const {
    chunkedRow,
    handleAddToPickList,
    isItemInDraftPickList,
    handleShowImage,
  } = props;

  const handleSelectedItem = (index) => {
    if (selectedItem === index) {
      setSelectedItem(false);
      return;
    }
    setSelectedItem(index);
  };

  useEffect(() => {
    setSelectedItem(false);
  }, [chunkedRow]);

  return (
    <Row>
      {chunkedRow.map((inventoryItem) => {
        const isPickable =
          !inventoryItem.PickListID &&
          !isItemInDraftPickList(inventoryItem) &&
          !inventoryItem.IsDelivered;
        return (
          <Col md="3" onClick={() => handleSelectedItem(inventoryItem)}>
            <Card>
              <Card.Img variant="top" src={inventoryItem.ili[0].FirstImage} />
              <Card.Body>
                {/* TODO: Select item
                <Form.Check type="checkbox" />
              */}
                <Card.Text>
                  <a
                    onClick={(e) => e.preventDefault()}
                    data-bs-toggle="collapse"
                    href="#inventory-grid-col-1"
                    role="button"
                    aria-expanded="false"
                    aria-controls="inventory-grid-col-1"
                  >
                    {inventoryItem.ItemName}
                  </a>
                </Card.Text>
              </Card.Body>
              <Card.Footer className="small">
                <a
                  href="#"
                  className={isPickable ? '' : 'default-pointer'}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (isPickable) {
                      handleAddToPickList(inventoryItem);
                    }
                  }}
                  color={isPickable ? '' : 'gray'}
                  style={{
                    opacity: isPickable ? 1 : 0.5,
                  }}
                >
                  Pick
                  <FontAwesomeIcon
                    color={isPickable ? '' : 'gray'}
                    style={{
                      opacity: isPickable ? 1 : 0.5,
                    }}
                    icon={faHandHoldingBox}
                    className="ms-2"
                  />
                </a>
                {/* <a href="#">
                Remove
                <FontAwesomeIcon icon={faBan} className="ms-2" />
              </a> */}
              </Card.Footer>
            </Card>
          </Col>
        );
      })}
      {selectedItem && (
        <Col sm={12}>
          <div className="info py-5 px-3" id="inventory-grid-col-1">
            <Row>
              <Col md={6} lg={3}>
                <img
                  src={selectedItem.ili[0].FirstImage}
                  alt=""
                  style={{ cursor: 'zoom-in' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShowImage(selectedItem.ili[0].FirstImage);
                  }}
                />
              </Col>
              <Col md={6} lg={3}>
                <div className="h3 fw-normal">{selectedItem.ItemName}</div>
                {selectedItem.ItemTag}
              </Col>
              <Col md={6} lg={3}>
                <Row>
                  <Col sm={6}>
                    <div className="fw-bold">Shipment</div>
                    {selectedItem.ShipmentNumber}
                  </Col>
                  <Col sm={6}>
                    <div className="fw-bold">Room</div>
                    {selectedItem.RoomName}
                  </Col>
                </Row>
              </Col>
              <Col md={6} lg={3}>
                <div className="fw-bold">Comments</div>
                {selectedItem.Comments}
              </Col>
            </Row>
          </div>
        </Col>
      )}
    </Row>
  );
}

InventoryGridRow.defaultProps = {
  chunkedRow: [],
};

InventoryGridRow.propTypes = {
  handleAddToPickList: PropTypes.func.isRequired,
  handleShowImage: PropTypes.func.isRequired,
  isItemInDraftPickList: PropTypes.func.isRequired,
  chunkedRow: PropTypes.arrayOf(
    PropTypes.shape({
      IsDelivered: bool,
      ShipmentNumner: number,
      InventoryItemID: string,
      ItemTag: string,
      LotID: string,
      Comments: string,
      StorageItemID: number,
      RoomID: string,
      RoomName: string,
      RoomComments: string,
      LocationID: string,
      LocaitonName: string,
      IsLocLocked: bool,
      Percentage: number,
      TotalItemInLocation: number,
      LocationTypeID: number,
      IsHighValue: bool,
      Value: number,
      Customer_ID: number,
      IsItemActive: bool,
      IsVoided: bool,
      Cube: number,
      InventoriedByID: number,
      BingoedByID: number,
      PreppedByID: number,
      LoadedByID: number,
      Height: number,
      Length: number,
      Width: number,
      ili: PropTypes.arrayOf(
        PropTypes.shape({
          LotName: string,
          IsLodLocked: bool,
          HasStorageItemID: number,
          DispLocID: string,
          Warehouse: string,
          InventoriedByName: string,
          BingoedByName: string,
          PreppedByName: string,
          LoadedByName: string,
          ImageCount: number,
          FirstImage: string,
        })
      ),
    })
  ),
};
